import Vue from "vue";
import App from "./App";
import router from "./router/index";
import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import store from "./store";
import VueNativeNotification from "vue-native-notification";
import StarRating from "vue-star-rating";
import { Datetime } from "vue-datetime";
import { JitsiMeet } from "@mycure/vue-jitsi-meet";
import VueExcelViewer from "@uublue/vue-excel-viewer";
import "@uublue/vue-excel-viewer/lib/vue-excel-viewer.css";
import "vue-datetime/dist/vue-datetime.css";
import VueMask from "v-mask";
import Tabs from "@/components/Tabs";
import FieldsList from "@/components/Item/FieldsList";
import CardItem from "@/components/Item/CardItem";
import VueYandexMetrika from 'vue-yandex-metrika'
import VCalendar from 'v-calendar';

// import VueI18n from 'vue-i18n'
// Vue.use(VueI18n)

Vue.use(VueExcelViewer);
Vue.component("datetime", Datetime);
Vue.use(VueMask);
Vue.use(PaperDashboard);
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  firstDay: 3
});

try {
  Vue.use(VueYandexMetrika, {
    id: process.env.METRIKA_ID,
    router: router,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  });
} catch (error) {

}

Vue.component("decision-text", () =>
  import("@/components/Item/Timetable/Decisions/Decision/Text")
);
Vue.component("decision-upload", () =>
  import("@/components/Item/Timetable/Decisions/Decision/Upload")
);
Vue.component("decision-test", () =>
  import("@/components/Item/Timetable/Decisions/Decision/Test")
);
Vue.component("decision-glue", () =>
  import("@/components/Item/Timetable/Decisions/Decision/Glue")
);
Vue.component("decision-order", () =>
  import("@/components/Item/Timetable/Decisions/Decision/Order")
);
Vue.component("locale", () => import("@/components/Locale"));
Vue.component("location", () => import("@/components/Location"));
Vue.component("role", () => import("@/components/Role"));
Vue.component("sub-field-list", () => import("@/components/Item/SubFieldList"));
Vue.component("img-upload", () => import("@/components/Inputs/ImgUpload"));
Vue.component("file-upload", () => import("@/components/Inputs/FileUpload"));
Vue.component("audio-upload", () => import("@/components/Inputs/AudioUpload"));
Vue.component("audio-upload-base", () => import("@/components/Inputs/AudioUploadBase"));
Vue.component("group-client-list", () =>
  import("@/components/Inputs/GroupClientList")
);
Vue.component("files-upload", () => import("@/components/Inputs/FilesUpload"));
Vue.component("zip-upload", () => import("@/components/Inputs/zipUpload"));
Vue.component("pdf-reader", () => import("@/components/PdfReader"));
Vue.component("tags", () => import("@/components/Tags"));
Vue.component("courses", () => import("@/components/Courses"));
Vue.component("images", () => import("@/components/Images"));
Vue.component("selectors", () => import("@/components/Inputs/Selectors"));
Vue.component("radio-list", () => import("@/components/Filters/RadioList"));
Vue.component("selector", () => import("@/components/Inputs/Selector"));
Vue.component("img-upload-base64", () =>
  import("@/components/Inputs/ImgUploadBase64")
);
Vue.component("language-list", () =>
  import("@/components/Filters/LanguageList")
);
Vue.component("set-language", () => import("@/components/SetLanguage"));
Vue.component("tabs", Tabs);
Vue.component("FieldsList", FieldsList);
Vue.component("card-item", CardItem);
Vue.component("filter-item", () => import("@/components/Filter"));
Vue.component("list", () => import("@/components/List"));
Vue.component("star-rating", StarRating);
Vue.component("VueJitsiMeet", JitsiMeet);
let items = store.state.items;
Object.keys(items).forEach((key) => {
  //console.log(items[key]);
  Vue.component(key, () => import(`@/components/Item/${items[key]}/index`));
});

try {
  Notification.requestPermission().then(() => { });
  Vue.use(VueNativeNotification, {
    requestOnNotify: true,
  });
} catch (error) { }


new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
